<script setup lang="ts">
import { TrellisButton, TrellisContainer, TrellisEmptyState } from '@akaal/trellis-ui'
import { useI18n } from 'vue-i18n'

import { MAIN_ID } from '@/shell/landmarks'

// What a user sees when a page throws (MRS 9): one sentence and a way on. The
// error itself goes to GlitchTip, never to the screen.
const emit = defineEmits<{ retry: [] }>()

const { t } = useI18n()
</script>

<template>
  <main :id="MAIN_ID" class="failure" data-test="error-view">
    <TrellisContainer size="sm">
      <TrellisEmptyState
        :heading-level="1"
        :title="t('failure.title')"
        :description="t('failure.description')"
        icon
        role="alert"
      >
        <template #action>
          <TrellisButton variant="primary" @click="emit('retry')">{{
            t('failure.action')
          }}</TrellisButton>
        </template>
      </TrellisEmptyState>
    </TrellisContainer>
  </main>
</template>

<style scoped>
.failure {
  padding-block: calc(var(--trellis-spacing) * 16);
}
</style>
